module.exports = "https://www.gc-qa.gnp.com.mx/3abc1688d504d8b5e85e97da81d0c330.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/vida/7.png
// module id = 383
// module chunks = 0 1